import './Dharma.css'
import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import { TeacherConfig } from 'src/configs/stream-entities'

class DharmaState {
    public teacherInfo: TeacherConfig = new TeacherConfig()
}

class DharmaProps {
    public teacherId: string = ''
}

class Dharma extends React.Component<DharmaProps, DharmaState> {
    private formRef: React.RefObject<HTMLFormElement>
    private teacherAccountObserve: firebase.Unsubscribe

    constructor(props: DharmaProps) {
        super(props)
        this.state = new DharmaState()
        this.onSubmit = this.onSubmit.bind(this)
        this.ondharmaChanged = this.ondharmaChanged.bind(this)
        this.formRef = React.createRef<HTMLFormElement>()
    }

    public componentDidUpdate(nextProps: DharmaProps, nextState: DharmaState) {
        if (this.props.teacherId !== undefined && nextProps.teacherId !== this.props.teacherId) {
            this.teacherAccountObserve = firebase.firestore().collection('users').doc(this.props.teacherId).onSnapshot(userSnap => {
                if (userSnap.exists) {
                    this.setState({ teacherInfo: Object.assign(new TeacherConfig, userSnap.data()) })
                }
            })
        }
    }

    public componentWillUnmount() {
        if (this.teacherAccountObserve !== undefined) {
            this.teacherAccountObserve()
        }
    }

    public render() {
        return (<div className="Dharma">
            <form className="DharmaForm" onSubmit={this.onSubmit} ref={this.formRef}>
                <label htmlFor="newDharma"> What is your new teacher share?</label><br />
                <textarea name="newDharma" onChange={this.ondharmaChanged} required={true} value={this.state.teacherInfo.dharma} className="newDharma" maxLength={90} />
                <input type="submit" className="newDharmaSubmit" />
            </form>
            {this.state.teacherInfo.dharmaURL !== undefined && this.state.teacherInfo.dharmaURL.length > 0 &&
                <div className="existingDharma">
                    <span> Your current dharma is:</span><br />
                    <img src={this.state.teacherInfo.dharmaURL} alt={this.state.teacherInfo.dharma} />
                </div>
            }
        </div>)
    }

    private ondharmaChanged(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const tInfo = this.state.teacherInfo
        tInfo.dharma = event.target.value
        this.setState({ teacherInfo: tInfo })
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            if (this.state.teacherInfo !== null) {
                const generateDharmaImage = firebase.functions().httpsCallable("generateDharmaImage")
                generateDharmaImage({ quote: this.state.teacherInfo.dharma, teacher: `${this.state.teacherInfo.firstname} ${this.state.teacherInfo.lastname}`, uuid: this.state.teacherInfo.uuid })
                    .then(result => {
                        console.log(result)
                        return firebase.storage().ref().child(result.data).getDownloadURL()
                    }).then(url => {
                        return firebase.firestore().collection('users').doc(this.state.teacherInfo.uuid).update({ dharma: this.state.teacherInfo.dharma, dharmaURL: url })
                    }).catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}

export default Dharma


// WEBPACK FOOTER //
// ./src/components/dharma/Dharma.tsx